import React from 'react';
import { MessagesProvider } from 'Views/Page/Content/Templates/MessagesPage/MessagesContext';
import { MessagesPageContent } from 'Views/Page/Content/Templates/MessagesPage/components/MessagesPageContent';
import { DockedContextProvider } from 'Context/DockedContext';
import { RightColumnProvider } from 'Context/RightColumnContext';

const MessagesPage = () => {
  return (
    <DockedContextProvider>
      <RightColumnProvider>
        <MessagesProvider>
          <MessagesPageContent />
        </MessagesProvider>
      </RightColumnProvider>
    </DockedContextProvider>
  );
};

export { MessagesPage };
